import createIcon from '../../createIcon';

/**
 * @component @name Badge
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgN0gxNVY0QzE1IDIuOSAxNC4xIDIgMTMgMkgxMUM5LjkgMiA5IDIuOSA5IDRWN0g0QzIuOSA3IDIgNy45IDIgOVYyMEMyIDIxLjEgMi45IDIyIDQgMjJIMjBDMjEuMSAyMiAyMiAyMS4xIDIyIDIwVjlDMjIgNy45IDIxLjEgNyAyMCA3Wk05IDEyQzkuODMgMTIgMTAuNSAxMi42NyAxMC41IDEzLjVDMTAuNSAxNC4zMyA5LjgzIDE1IDkgMTVDOC4xNyAxNSA3LjUgMTQuMzMgNy41IDEzLjVDNy41IDEyLjY3IDguMTcgMTIgOSAxMlpNMTIgMThINlYxNy4yNUM2IDE2LjI1IDggMTUuNzUgOSAxNS43NUMxMCAxNS43NSAxMiAxNi4yNSAxMiAxNy4yNVYxOFpNMTMgOUgxMVY0SDEzVjlaTTE4IDE2LjVIMTRWMTVIMThWMTYuNVpNMTggMTMuNUgxNFYxMkgxOFYxMy41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Badge = createIcon('Badge', [
  [
    'path',
    {
      d: 'M20 7H15V4C15 2.9 14.1 2 13 2H11C9.9 2 9 2.9 9 4V7H4C2.9 7 2 7.9 2 9V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V9C22 7.9 21.1 7 20 7ZM9 12C9.83 12 10.5 12.67 10.5 13.5C10.5 14.33 9.83 15 9 15C8.17 15 7.5 14.33 7.5 13.5C7.5 12.67 8.17 12 9 12ZM12 18H6V17.25C6 16.25 8 15.75 9 15.75C10 15.75 12 16.25 12 17.25V18ZM13 9H11V4H13V9ZM18 16.5H14V15H18V16.5ZM18 13.5H14V12H18V13.5Z',
      key: 'gg6zb0',
    },
  ],
]);

export default Badge;
